import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";

export default function HomeWhatOurCustomerSays() {
    return (
        <>

            <section className="eq-feedback-section ptb-120">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-12 col-lg-9">
                            <div className="section-title ps-sm-3 text-center">
                                <h2 className="text-eq-primary justify-content-center down-shadow">O que nossos clientes dizem?</h2>
                                {/*<p className="mb-3 fw-bold text-black">O Que Nossos Clientes Dizem?</p>
                                <p className="mb-0">Está em nosso DNA dar o melhor atendimento aos nossos clientes, gerando a melhor experiência de compra de veículos do mercado.</p>*/}
                            </div>
                        </div>
                    </div>
                    <div className="py-5 px-sm-3">
                        <Swiper
                            speed={3500}
                            loop={true}
                            slidesPerView={3}
                            spaceBetween={24}
                            autoplay={{
                                delay: 3500,
                                disableOnInteraction: false
                            }}
                            pagination={{
                                el: ".eq-feedback-pagination",
                                type: "bullets",
                                clickable: true
                            }}
                            breakpoints={{
                                [0]: { slidesPerView: 1 },
                                [768]: { slidesPerView: 2 },
                                [1200]: { slidesPerView: 3 }
                            }}
                            modules={[Pagination, Autoplay]}
                        >
                            <SwiperSlide className="size">
                                <div>
                                    <div className="info-comment">
                                        <div className="user-circle">
                                            <i className="fa-regular fa-user"></i>
                                        </div>
                                        <span>Guarudrones Guarujá</span>
                                    </div>
                                    {/*<span className="quote-icon align-items-center justify-content-center rounded-circle position-relative">
                                    <i className="fa-regular fa-user"></i>
                                </span>*/}
                                    <p className="mt-4 mb-3 fs-md">
                                        Eu fui sem saber como seria. Mas fiz um ótimo negócio. O proprietário me auxiliando em tudo me entregou o carro todo revisado. Em nenhum momento se omitiram de nada. Com certeza eu indico este local para fazer negócios.
                                    </p>
                                    <div className="info-comment">
                                        <i className="fa-regular fa-heart"></i>
                                        <i className="fa-regular fa-comment"></i>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="size">
                                <div>
                                    <div className="info-comment">
                                        <div className="user-circle">
                                            <i className="fa-regular fa-user"></i>
                                        </div><span>Nailton Miranda</span>
                                    </div>
                                    {/*<span className="quote-icon align-items-center justify-content-center rounded-circle position-relative">
                                    <i className="fa-regular fa-user"></i>
                                </span>*/}
                                    <p className="mt-4 mb-3 fs-md">
                                        Atendimento ótimo e pós venda espetacular, comprei uma Santa Fe e estava com o pneu vazando, é um odor forte de gasolina interno, levei na loja em 2 dias repararam tudo e ainda me deram garantia do serviço, super recomendo!!!
                                    </p>
                                    <div className="info-comment">
                                        <i className="fa-regular fa-heart"></i>
                                        <i className="fa-regular fa-comment"></i>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="size">
                                <div>
                                    <div className="info-comment">
                                        <div className="user-circle">
                                            <i className="fa-regular fa-user"></i>
                                        </div><span>Mariana Vieira</span>
                                    </div>
                                    {/*<span className="quote-icon align-items-center justify-content-center rounded-circle position-relative">
                                    <i className="fa-regular fa-user"></i>
                                </span>*/}
                                    <p className="mt-4 mb-3 fs-md">Carros e atendimento eficazes, comprometimento com o cliente e serviço de primeira qualidade</p>
                                    <div className="info-comment">
                                        <i className="fa-regular fa-heart"></i>
                                        <i className="fa-regular fa-comment"></i>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </section>

        </>
    );
}